var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061E37",
    d: "M3.06967251,6.059622 L1.25552445,8.42590208 C1.02030523,8.73270976 0.580905603,8.79074368 0.274097919,8.55552445 C-0.0327097641,8.32030523 -0.0907436769,7.8809056 0.144475547,7.57409792 L2.44447555,4.57409792 C2.70184499,4.23839865 3.19586521,4.20591572 3.49497475,4.50502525 L5.96838904,6.97843955 L10.7753688,1.53657573 C11.0313109,1.24682989 11.4736784,1.2194266 11.7634243,1.47536875 C12.0531701,1.73131091 12.0805734,2.17367843 11.8246312,2.46342427 L6.52463125,8.46342427 C6.25741925,8.76592842 5.79042937,8.78037886 5.50502525,8.49497475 L3.06967251,6.059622 Z",
    transform: "translate(0 -1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveIcon);
export default __webpack_public_path__ + "static/media/curve-icon.d76d7ac473bf90e47457c33945449486.svg";
export { ForwardRef as ReactComponent };